import { createRedux } from 'src/firebase';
import { State } from 'src/store';

const {
  actions,
  actionTypes,
  collectionReducer: statesReducer,
  docReducer: stateDetailReducer,
} = createRedux<State>('states');

export {
  actions,
  actionTypes,
  statesReducer,
  stateDetailReducer,
};



// WEBPACK FOOTER //
// ./src/states/redux.ts